import isDesktop from '@lib/is-desktop';
import { desktopMediaQuery } from '@lib/media-query';

window.Drupal.behaviors['SampleBoxOrderForm'] = {
    attach(context: Document | HTMLElement) {
        const parentContext = context === document ? context : context.parentElement;
        if (!parentContext) return;

        parentContext
            .querySelectorAll<HTMLFormElement>('form.sample-box-order-form:not(.js-sample-box-order-form)')
            .forEach((form) => {
                form.classList.add('js-sample-box-order-form');
                introductionMovingShowingHidingAndDimmingOfElement(form);
                positionProgressElement(form);
            });
    },
};

function introductionMovingShowingHidingAndDimmingOfElement(form: HTMLFormElement) {
    const NONE_CHECKED_CLASSNAME = 'none-checked';
    const FIRST_CHECKED_CLASSNAME = 'first-checked';
    const SECOND_CHECKED_CLASSNAME = 'second-checked';

    const radiosFieldset = form.querySelector<HTMLFieldSetElement>(
        '[data-drupal-selector="edit-introduction-profession"]'
    );
    const radios = [...form.querySelectorAll<HTMLInputElement>('[name=introduction_profession]')];
    const input = form.querySelector<HTMLInputElement>('[name=introduction_name]');
    const submit = form.querySelector<HTMLButtonElement>(
        '.sample-box-order-form-actions--page-first button[type=submit].webform-button--next'
    );

    const unicornText = form.querySelector<HTMLDivElement>('.sample-box-order-form-element--introduction-unicorn-text');
    unicornText?.parentElement?.classList.add('sample-box-order-form-unicorn-wrapper');

    const applyVisibilityClasses = () => {
        const els = [input, submit, input?.parentElement];
        toggleClass(els, FIRST_CHECKED_CLASSNAME, radios[0]?.checked);
        toggleClass(els, SECOND_CHECKED_CLASSNAME, radios[1]?.checked);
        toggleClass(els, NONE_CHECKED_CLASSNAME, radios[2]?.checked);

        if (radios.some((radio) => radio.checked)) {
            radiosFieldset?.classList.add('js-value-checked');
        }

        if (radios.every((radio) => !radio.checked)) {
            submit?.classList.add(NONE_CHECKED_CLASSNAME);
        }
    };

    const moveElementOnMobile = () => {
        if (!input || !input.parentElement || !submit) return;

        const getTop = (radio: HTMLInputElement) => {
            if (!radio.parentElement) return 0;
            return radio.parentElement.offsetTop + radio.parentElement.offsetHeight + 16;
        };

        if (!isDesktop()) {
            const checkedRadio = radios.find((radio) => radio.checked);
            if (checkedRadio) {
                const top = getTop(checkedRadio);
                input.parentElement.style.top = top + 'px';
                submit.style.top = top + 'px';
            }
        } else {
            input.parentElement.style.removeProperty('top');
            submit.style.removeProperty('top');
        }
    };

    const focusInput = () => {
        if (radios[0]?.checked || radios[1]?.checked) input?.focus();
    };

    applyVisibilityClasses();
    moveElementOnMobile();

    radios.forEach((radio) => {
        radio.addEventListener('change', () => {
            applyVisibilityClasses();
            moveElementOnMobile();
            focusInput();
        });
    });

    if (input && input.parentElement && submit) {
        desktopMediaQuery().addListener(moveElementOnMobile);

        new ResizeObserver(moveElementOnMobile).observe(form);
    }
}

function positionProgressElement(form: HTMLFormElement): void {
    function updatePosition() {
        const progress = form.querySelector<HTMLDivElement>('.sample-box-order-form__progress');
        const headline = form.querySelector<HTMLHeadingElement>('.sample-box-order-form-variables__headline');

        if (progress && headline) {
            if (isDesktop()) {
                progress.style.top = headline.offsetTop + 25 + 'px';
            } else {
                progress.style.top = headline.offsetTop - progress.offsetHeight - 2 + 'px';
            }
        }
    }

    updatePosition();

    const resizeObserver = new ResizeObserver(() => updatePosition());
    resizeObserver.observe(form);
}

function toggleClass(
    el: (HTMLElement | undefined | null)[] | HTMLElement | null | undefined,
    className: string,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    condition: any
): void {
    el = Array.isArray(el) ? el : [el];
    if (condition) {
        el.forEach((e) => e?.classList.add(className));
    } else {
        el.forEach((e) => e?.classList.remove(className));
    }
}
